import { default as axios } from "axios";

export class GccsSetUser {
    path = "http://192.168.1.34:9000/gccs/set/user"
    post(param) {
        return axios.post(this.path,param)
    }
}